var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("EmployeeCard", {
    staticClass: "h-full",
    attrs: {
      avatar: _vm.avatar,
      givenName: _vm.givenName,
      familyName: _vm.familyName,
      employeeUserId: _vm.employeeUserId,
      employeePageRouteParams: _vm.employeePageRouteParams,
      available: _vm.available,
      country: _vm.country,
      city: _vm.city,
      userUpdatedDate: _vm.userUpdatedDate,
      nameBlockMinHeight: _vm.nameBlockMinHeightValue,
    },
    on: {
      "update:nameBlockMinHeight": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
      "update:name-block-min-height": function ($event) {
        _vm.nameBlockMinHeightValue = $event
      },
    },
    scopedSlots: _vm._u(
      [
        {
          key: "avatarPrimary",
          fn: function () {
            return [_vm._t("avatarPrimary")]
          },
          proxy: true,
        },
        {
          key: "avatarSecondary",
          fn: function () {
            return [_vm._t("avatarSecondary")]
          },
          proxy: true,
        },
        {
          key: "avatarInfo",
          fn: function () {
            return [_vm._t("avatarInfo")]
          },
          proxy: true,
        },
        {
          key: "nameBlock",
          fn: function ({ status, employeePageRouteParams }) {
            return [
              _vm._t("nameBlock", null, {
                status: status,
                employeePageRouteParams: employeePageRouteParams,
              }),
            ]
          },
        },
        {
          key: "content",
          fn: function ({ location }) {
            return [
              _c("CardItemBaseContainer", {
                attrs: {
                  title: "Title",
                  value: _vm.jobTitle,
                  highlightValue: "",
                },
              }),
              _c("CardItemBaseContainer", {
                attrs: { title: "Rate", value: _vm.rates },
              }),
              _c("CardItemBaseContainer", {
                attrs: { title: "Location", value: location },
              }),
              _c("CardItemBaseContainer", {
                staticClass: "mb-4",
                attrs: { title: "Company", value: _vm.companyName },
              }),
              _c(
                "ContainerSize",
                {
                  staticClass: "mb-4",
                  attrs: { minHeight: _vm.skillsBlockMinHeightValue },
                  on: {
                    "update:minHeight": function ($event) {
                      _vm.skillsBlockMinHeightValue = $event
                    },
                    "update:min-height": function ($event) {
                      _vm.skillsBlockMinHeightValue = $event
                    },
                  },
                },
                [
                  _c("CardItemChipsContainer", {
                    attrs: { title: "Skills", collection: _vm.skillss },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ collection }) {
                            return [
                              _c("ChipsWithMore", {
                                attrs: {
                                  chipWithLinkDatas: collection,
                                  wrapChips: true,
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _vm._t("content"),
            ]
          },
        },
        {
          key: "startActions",
          fn: function () {
            return [_vm._t("actions")]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }